import { NotFoundView } from "./Misc";

export default function NotFound() {
  return <NotFoundView />;
}
